import React from 'react';
import { Heart, Star, MessageCircle, Zap, ShieldCheck } from 'lucide-react';
import { motion } from 'framer-motion';
const reasons = [{
  icon: Heart,
  title: 'Hago cada pedido personalmente',
  text: 'Sin asistentes ni IA. Cuando pedís, me siento y hago tu trabajo yo misma, siempre.'
}, {
  icon: Star,
  title: 'Más de 10 años de práctica real',
  text: 'Hago esto hace más de una década. No es un hobby, es mi vocación y mi forma de vida.'
}, {
  icon: Zap,
  title: 'Entrega rápida y soporte',
  text: 'Sé que cuando necesitás claridad, la necesitás ya. Todo llega directo a tu correo.'
}, {
  icon: MessageCircle,
  title: 'Estoy con vos de por vida',
  text: 'Respondé en cualquier momento con preguntas. Estoy en todo el camino.'
}, {
  icon: ShieldCheck,
  title: 'Privacidad completa',
  text: 'Todo lo que compartís conmigo queda entre nosotras.'
}];
export function WhyChooseMe() {
  return <section className="w-full py-20 px-4 bg-gradient-to-b from-[#14100c] via-[#1a1510] to-[#14100c] border-y border-[#D4AF37]/10" data-id="element-323">
      <div className="max-w-4xl mx-auto" data-id="element-324">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="font-playfair text-3xl sm:text-4xl text-center text-white mb-16" data-id="element-325">
          ¿Por qué las clientas{' '}
          <span className="text-gradient-gold italic" data-id="element-326">confían en mí?</span>
        </motion.h2>

        <div className="flex flex-col gap-8 sm:gap-10" data-id="element-327">
          {reasons.map((reason, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="flex gap-5 sm:gap-6 items-start" data-id="element-328">
              <div className="flex-shrink-0 w-12 h-12 sm:w-14 sm:h-14 rounded-full bg-[#111] border border-[#D4AF37]/20 flex items-center justify-center text-[#D4AF37] shadow-[0_0_15px_rgba(212,175,55,0.1)]" data-id="element-329">
                <reason.icon className="w-6 h-6 sm:w-7 sm:h-7" data-id="element-330" />
              </div>
              <div className="flex flex-col pt-1" data-id="element-331">
                <h3 className="font-playfair text-xl sm:text-2xl text-white mb-2" data-id="element-332">
                  {reason.title}
                </h3>
                <p className="font-inter text-gray-400 text-sm sm:text-base leading-relaxed" data-id="element-333">
                  "{reason.text}"
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}